import {
  createTableNavigationInput,
  type SelectionUiInteraction,
  type SharedEventLoop,
  type TableNavigationAdapter,
} from '@databases/selections';
import { DatabaseLayoutType } from '@databases/types/database/view';
import { TABLE_V2_LAYOUT_ID } from '@databases/view-layout-table-v2/id';

import {
  type SelectionInputFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export interface TableNavigationKeyboardInputFeatureDeps {
  sharedLoop: SharedEventLoop;
  adapter: TableNavigationAdapter;
  onSelectionUiInteraction?: (event: SelectionUiInteraction) => void;
}

/**
 * Registers table grid navigation.
 *
 * This remains table-layout scoped because the selections package needs an app
 * adapter for visible row and field order.
 */
export function createTableNavigationKeyboardInputFeature(
  deps: TableNavigationKeyboardInputFeatureDeps,
): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.TABLE_NAVIGATION_KEYBOARD_INPUT,
    type: 'input',
    isEnabled: (ctx) =>
      ctx.layoutType === DatabaseLayoutType.TABLE ||
      ctx.layoutType === TABLE_V2_LAYOUT_ID,
    factory: (machine) =>
      createTableNavigationInput(machine, deps.sharedLoop, {
        adapter: deps.adapter,
        onSelectionUiInteraction: deps.onSelectionUiInteraction,
      }),
  };
}
